import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const services = [
  {
    name: "Solar Preventive Maintenance",
    path: "/solar-preventive-maintaince",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/full-service_l7ppid.png",
  },
  {
    name: "PV Installation",
    path: "/pv-installation",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/pv-installation_qinoh9.png",
  },
  {
    name: "PV Bird Proofing",
    path: "/bird-proofing",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/bird-roofing_ozqlpa.png",
  },
  {
    name: "Handling Manufacturing Warranty",
    path: "/warranty",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/handling-warranty_ldy68k.png",
  },
  {
    name: "Health Report",
    path: "/health-report",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/plant-report_vk9r0i.png",
  },
  {
    name: "System Repair",
    path: "/system-repair",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/system-repair_mvsud1.png",
  },
  {
    name: "Consultation",
    path: "/consultation",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/consultation_rnucog.png",
  },
  {
    name: "PV Protection Coatings",
    path: "/pv-protection-coatings",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749990820/pv-coating_tblg4l.png",
  },
];

export default function ServiceNavigator() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentIndex = services.findIndex((s) => s.path === location.pathname);

  const handlePrev = () => {
    if (currentIndex > 0) navigate(services[currentIndex - 1].path);
  };

  const handleNext = () => {
    if (currentIndex < services.length - 1) navigate(services[currentIndex + 1].path);
  };

  return (
    <div className="flex flex-col items-center mt-10 mb-16 px-4">
      {/* Prev / Next */}
      <div className="flex justify-between w-full max-w-2xl mb-8">
        <button
          onClick={handlePrev}
          disabled={currentIndex === 0}
          className="flex items-center gap-2 px-3 sm:px-6 py-2 rounded-full border border-gray-300 text-gray-700 bg-white 
                     hover:bg-gray-100 transition disabled:opacity-40 disabled:cursor-not-allowed text-sm sm:text-base"
        >
          <FontAwesomeIcon icon={faChevronLeft} /> Previous
        </button>
        <button
          onClick={handleNext}
          disabled={currentIndex === services.length - 1}
          className="flex items-center gap-2 px-3 sm:px-6 py-2 rounded-full bg-black text-white 
                     hover:bg-gray-800 transition disabled:opacity-40 disabled:cursor-not-allowed text-sm sm:text-base"
        >
          Next <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      {/* Mobile 4-column button grid */}
      {/* Mobile 4-column button grid with names */}
<div className="grid grid-cols-4 gap-2 w-full sm:hidden mb-8">
  {services.map((service, index) => (
    <button
      key={service.path}
      onClick={() => navigate(service.path)}
      className={`flex flex-col items-center justify-center p-2 rounded-lg border text-center transition ${
        index === currentIndex
          ? "bg-black text-white border-black"
          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
      }`}
    >
      <img
        src={service.img}
        alt={service.name}
        className="h-8 w-8 object-contain mb-1"
      />
      <span className="text-[10px] leading-tight">{service.name}</span>
    </button>
  ))}
</div>


      {/* Services Grid for tablet & desktop */}
      <div className="hidden sm:grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        {services.map((service, index) => (
          <button
            key={service.path}
            onClick={() => navigate(service.path)}
            className={`group card-gradient-hover flex flex-col items-center p-6 md:p-8 rounded-3xl transition-all duration-300 
              ${index === currentIndex
                ? "bg-black text-white scale-105 shadow-2xl"
                : "bg-white text-gray-800 border border-gray-200 hover:shadow-xl hover:-translate-y-2"
              }`}
          >
            <img
              src={service.img}
              alt={service.name}
              className={`h-20 md:h-24 w-auto object-contain mb-4 md:mb-6 transition-transform duration-500 
                ${index === currentIndex ? "scale-110" : "group-hover:scale-110"}`}
            />
            <div className="font-semibold text-base md:text-lg text-center leading-snug">
              {service.name}
            </div>
            <div
              className={`mt-2 md:mt-3 text-xs md:text-sm font-medium opacity-0 translate-y-2 transition-all duration-300 
                group-hover:opacity-100 group-hover:translate-y-0
                ${index === currentIndex ? "text-blue-300 opacity-100 translate-y-0" : "text-blue-600"}`}
            >
              Learn More &gt;
            </div>
          </button>
        ))}
      </div>

      {/* Current Service */}
      <div className="mt-8 text-gray-500 text-sm sm:text-lg font-medium text-center">
        Viewing: <span className="text-black">{services[currentIndex]?.name}</span>
      </div>
    </div>
  );
}
